import styled from 'styled-components';

export const FilteredDetails = styled('div')`
  width: 200px;
  min-width: 200px;
  max-height: 200px;
  height: 200px
  overflow-y: scroll;
  overflow: hidden;
`;

export const ChildDiv = styled('div')`
  max-height: inherit;
  overflow-y: scroll;
`;

export const ClearFilterButton = styled('button')`
  background: none;
  border: none;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 12px;
  text-decoration: underline;
  margin-top: 15px;
  &:hover {
    cursor: pointer;
  }
  width: 175px;
`;
